import { render, staticRenderFns } from "./givingBottomBanner.vue?vue&type=template&id=7940a873&scoped=true&"
import script from "./givingBottomBanner.vue?vue&type=script&lang=js&"
export * from "./givingBottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./givingBottomBanner.vue?vue&type=style&index=0&id=7940a873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940a873",
  null
  
)

export default component.exports